import SvgAngleDown from '@img/icons/angle-down.svg';
import { FocusRing, useFocusManager } from '@react-aria/focus';
import * as React from 'react';
import S from '../Accordion.styles';
import { useAccordion } from '../Context/Context';
const AccordionItem = (props) => {
    const accordion = useAccordion();
    const fm = useFocusManager();
    const isActive = accordion.activeId === props.id;
    const headerId = `${props.id}-header`;
    const bodyId = `${props.id}-body`;
    return (React.createElement(S.Item, { initial: isActive ? 'opened' : 'closed', animate: isActive ? 'opened' : 'closed', onKeyDown: (event) => {
            switch (event.key) {
                case 'ArrowDown':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusNext();
                    break;
                case 'ArrowUp':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusPrevious();
                    break;
                case 'Home':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusFirst();
                    break;
                case 'End':
                    event.preventDefault();
                    event.stopPropagation();
                    fm.focusLast();
                    break;
                default:
                    break;
            }
        } },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.ItemHeader, { id: headerId, "aria-controls": bodyId, "aria-expanded": isActive, type: "button", onClick: (event) => {
                    event.preventDefault();
                    accordion.onClick(props.id);
                } },
                React.createElement(S.ItemTitle, null, props.title),
                React.createElement(S.ItemIcon, { "aria-hidden": "true" },
                    React.createElement(SvgAngleDown, null)))),
        React.createElement(S.ItemBody, { id: bodyId, "aria-labelledby": headerId, role: "region", tabIndex: -1, variants: {
                closed: {
                    height: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                },
                opened: {
                    visibility: 'visible',
                    height: 'auto',
                },
            } },
            React.createElement(S.ItemBodyContent, null, props.children))));
};
export default AccordionItem;
